import { GetterTree } from "vuex";
import { RootState } from "../types";
import { HomeState } from "./types";

export const getters: GetterTree<HomeState, RootState> = {};
